import React from "react";
import reactDom from "react-dom";
// import './LandingScreen.css'

const LandingScreen = () => {
  return (
    <div className="landing-screen">
      <h3 className="landing-words animatedTitle animatedFadeInUp fadeInUp">
        UI/UX DESIGNER & RESEARCHER
      </h3>
      <h1 className="landingname animatedName animatedFadeInUp fadeInUp">
        Prasetyo Utomo
      </h1>
    </div>
  );
};

export default LandingScreen;
